import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/services/api';
import { WARNING_DAYS_PERSONAL, getExpiryStatus } from '@vvf/shared';
import { TOAST_HIDE_MS } from './timing';

/**
 * Avvisi scadenze personali al primo accesso alla dashboard.
 * Mostra un pannello slide-in in alto a destra per 15 secondi
 * se l'utente ha visite mediche o patenti in scadenza (<= 90gg).
 */
export function ExpiryAlerts(): React.JSX.Element | null {
  const [visible, setVisible] = useState(true);
  const { data: medical } = useQuery({
    queryKey: ['locker.medical'],
    queryFn: async () => (await api.get('/profile/medical-checks')).data,
  });
  const { data: licenses } = useQuery({
    queryKey: ['locker.licenses'],
    queryFn: async () => (await api.get('/profile/licenses')).data,
  });

  useEffect(() => {
    const t = setTimeout(() => setVisible(false), TOAST_HIDE_MS);
    return () => clearTimeout(t);
  }, []);

  if (!visible) return null;

  const medicalAlerts = (medical ?? []).filter((m: { expiryDate: string }) => {
    const s = getExpiryStatus(m.expiryDate, WARNING_DAYS_PERSONAL);
    return s === 'InScadenza' || s === 'NonIdoneo';
  });
  const licenseAlerts = (licenses ?? []).filter((l: { expiryDate: string }) => {
    const s = getExpiryStatus(l.expiryDate, WARNING_DAYS_PERSONAL);
    return s === 'InScadenza' || s === 'NonIdoneo';
  });

  if (medicalAlerts.length === 0 && licenseAlerts.length === 0) return null;

  return (
    <div style={{
      position: 'fixed', top: 80, right: 20, zIndex: 900,
      background: '#fff', border: '2px solid #f39c12',
      borderRadius: 10, padding: 16, maxWidth: 360,
      boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
      animation: 'slideIn 0.4s ease-out',
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <strong style={{ color: '#f39c12' }}>⚠ Scadenze in avvicinamento</strong>
        <button onClick={() => setVisible(false)}
          style={{ background: 'none', padding: 2, fontSize: 18, color: '#666' }}>✕</button>
      </div>
      {medicalAlerts.length > 0 && (
        <div style={{ marginTop: 8, fontSize: 13 }}>
          <strong>Visite mediche:</strong>
          <ul style={{ margin: '4px 0', paddingLeft: 20 }}>
            {medicalAlerts.map((m: { id: string; expiryDate: string }) => (
              <li key={m.id}>Scade il {m.expiryDate}</li>
            ))}
          </ul>
        </div>
      )}
      {licenseAlerts.length > 0 && (
        <div style={{ marginTop: 8, fontSize: 13 }}>
          <strong>Patenti:</strong>
          <ul style={{ margin: '4px 0', paddingLeft: 20 }}>
            {licenseAlerts.map((l: { id: string; type: string; expiryDate: string }) => (
              <li key={l.id}>{l.type} — scade il {l.expiryDate}</li>
            ))}
          </ul>
        </div>
      )}
      <a href="/locker" style={{ fontSize: 12 }}>→ Gestisci armadietto</a>
    </div>
  );
}
